import { NgModule } from '@angular/core';
import {
  NavigationToolbarComponent,
  ToolbarRightDirective,
  TooolbarLeftDirective,
} from './navigation-toolbar.component';

export { NavigationToolbarComponent } from './navigation-toolbar.component';

export const MODULE_IMPORTS_AND_EXPORTS = [NavigationToolbarComponent, ToolbarRightDirective, TooolbarLeftDirective];

@NgModule({
  imports: MODULE_IMPORTS_AND_EXPORTS,
  exports: MODULE_IMPORTS_AND_EXPORTS,
})
export class GalaxyNavigationToolbarModule {}
